export default "__VITE_ASSET__9dfed554__"